import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories, articles, featuredArticles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function Home() {
  const [activeFaq, setActiveFaq] = useState<number | null>(null);

  const faqs = [
    { q: '奶妈动漫是什么？', a: '奶妈动漫是国内首家专注于母乳哺育题材与动漫文化交汇的内容平台。我们汇聚原创漫画、角色设定、同人创作与育儿科普，为动漫爱好者和年轻父母提供温情治愈的内容体验。' },
    { q: '如何投稿原创作品？', a: '我们非常欢迎原创作者的加入！您可以将作品发送至投稿邮箱 hello@naimadongman.com，我们的编辑团队会在3个工作日内回复。请附上作品简介和个人简介。' },
    { q: '平台内容是否经过专业审核？', a: '是的。所有育儿科普类内容均由我们的医学顾问——三甲医院儿科医生和国际认证泌乳顾问审核，确保信息准确可靠。' },
    { q: '如何加入创作者社区？', a: '您可以通过关注我们的社交媒体账号（微博@奶妈动漫官方）或直接发送邮件申请加入。我们的社区已有超过150位活跃画师和5万多名成员。' },
  ];

  const latestArticles = articles.filter((a) => !a.featured).slice(0, 6);

  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '奶妈动漫',
    url: 'https://naimadongman.com',
    description: '母乳哺育与动漫文化融合平台，汇聚原创作品、角色设定、同人创作及育儿知识科普',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://naimadongman.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '奶妈动漫',
    url: 'https://naimadongman.com',
    description: '母乳哺育与动漫文化融合平台',
    email: 'hello@naimadongman.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '杭州',
      addressRegion: '浙江',
      addressCountry: 'CN',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(homepageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20and%20healing%20anime%20style%20illustration%20of%20a%20mother%20gently%20embracing%20her%20baby%20surrounded%20by%20soft%20golden%20light%20and%20floating%20cherry%20blossoms%2C%20dreamy%20pastel%20atmosphere%2C%20warm%20pink%20and%20cream%20tones%2C%20ethereal%20and%20tender%20composition%2C%20anime%20art%20style%20with%20soft%20gradients%20and%20gentle%20bokeh&width=1600&height=900&seq=hero-nurse-anime&orientation=landscape"
            alt="奶妈动漫 - 母乳哺育与动漫文化融合平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
          <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
            <h1 className="font-heading text-2xl md:text-4xl text-white mb-4 leading-tight animate-fade-in">
              奶妈动漫
            </h1>
            <p className="text-sm md:text-lg text-white/90 mb-3 max-w-xl mx-auto leading-relaxed animate-fade-in-up animate-delay-100">
              母乳哺育与动漫文化融合平台
            </p>
            <p className="text-xs md:text-sm text-white/70 mb-8 max-w-lg mx-auto leading-relaxed animate-fade-in-up animate-delay-200">
              汇聚原创作品、角色设定、同人创作及育儿知识科普，为动漫爱好者与年轻父母提供温情治愈的优质内容体验
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up animate-delay-300">
              <Link
                to="/category/yuanchuang"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                探索原创作品
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-md text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-6xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 text-center mb-10">
              探索内容分类
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/50 transition-all duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-400">{cat.count}篇</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
                精选推荐
              </h2>
              <Link
                to="/category/yuanchuang"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {featuredArticles.map((article) => {
                const cat = categories.find((c) => c.id === article.category);
                return (
                  <ArticleCard
                    key={article.id}
                    article={article}
                    categorySlug={cat?.slug || ''}
                    categoryName={cat?.name || ''}
                  />
                );
              })}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
                最新文章
              </h2>
              <Link
                to="/category/yuanchuang"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
              >
                更多文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {latestArticles.map((article) => {
                const cat = categories.find((c) => c.id === article.category);
                return (
                  <ArticleCard
                    key={article.id}
                    article={article}
                    categorySlug={cat?.slug || ''}
                    categoryName={cat?.name || ''}
                  />
                );
              })}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-accent-100/60">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              {[
                { value: '200+', label: '原创作品' },
                { value: '150+', label: '活跃画师' },
                { value: '50,000+', label: '社区成员' },
                { value: '80+', label: '科普文章' },
              ].map((stat, i) => (
                <div key={i} className="py-4">
                  <div className="text-2xl md:text-3xl font-heading text-accent-600 mb-1">{stat.value}</div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 text-center mb-10">
              常见问题
            </h2>
            <div className="flex flex-col gap-3">
              {faqs.map((faq, i) => (
                <div
                  key={i}
                  className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    onClick={() => setActiveFaq(activeFaq === i ? null : i)}
                  >
                    <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                    <i
                      className={`${activeFaq === i ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 text-lg flex-shrink-0`}
                    ></i>
                  </button>
                  {activeFaq === i && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-lg mx-auto text-center">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-3">
              订阅我们的通讯
            </h2>
            <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
              获取最新的奶妈动漫原创作品、角色设定和育儿科普内容
            </p>
            <NewsletterForm />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      return;
    }

    if (!email.trim()) {
      setErrorMsg('请输入邮箱地址');
      setStatus('error');
      return;
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9sn37d8o1vn02ekui8g', {
        method: 'POST',
        body: formData,
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="py-8 text-center">
        <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
          <i className="ri-check-line text-2xl"></i>
        </div>
        <p className="text-foreground-800 font-medium">订阅成功！</p>
        <p className="text-sm text-foreground-500 mt-1">感谢您的订阅，我们将为您推送最新内容。</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} data-readdy-form="">
      <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setErrorMsg(''); setStatus('idle'); }}
          placeholder="请输入您的邮箱地址"
          required
          className="flex-1 px-4 py-3 text-sm bg-background-50 border border-background-300 rounded-md focus:outline-none focus:border-primary-400 transition-colors"
        />
        <button
          type="submit"
          className="px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          立即订阅
        </button>
      </div>
      {status === 'error' && errorMsg && (
        <p className="text-sm text-red-500 mt-2">{errorMsg}</p>
      )}
    </form>
  );
}